import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Subscribe from './pages/Subscribe';
import Payment from './pages/Payment';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import Guide from './pages/Guide';
import SmartsecureTermsPage from './pages/SmartsecureTermsPage';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/auth" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/terms-of-use" element={<SmartsecureTermsPage />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="/guide" element={<Guide />} />
      </Routes>
    </div>
  );
}

export default App;
